import { Transaction } from './transaction';

export class Reservation extends Transaction {
  eventReservationId: number;
  status: string;
  source: string;
  rooms: number;
  roomNights: number;
  ratePlanCode: string;
  groupCode: string;
}

export class TransientReservation extends Reservation {
  selected: boolean;
  chainCode: string;
  brandCode: string;
  property: string;
  ratePlanCode: string;
  paymentRecordNumber: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/reservation.ts